import React from 'react';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { Route } from 'react-router-dom';
import firebase from '../firebase';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#009EBD',
      light: '#33b1ca',
      dark: '#006e84'
    },
  }
});

const RouteLayout = ({component: Component, ...rest}) => (
  <Route {...rest} render={matchProps => {
    if(rest.requireAuth) {
      const auth = firebase.auth();
      auth.onAuthStateChanged((user) => {
        if(!user) {
          matchProps.history.push("/login");
        }
      });
    }
    return (
      <MuiThemeProvider theme={theme}>
        <Component {...matchProps} />
      </MuiThemeProvider>
    );
  }} />
);

export default RouteLayout;


// WEBPACK FOOTER //
// ./src/components/RouteLayouts.js